export const appBuildAssetsDir = "/_nuxt/1749115075671/"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"google-site-verification","content":"sLW7V50Dnjhi9gIwpytwMNMMYkX0XpYdReNWi0AX--A"},{"name":"google-site-verification","content":"prmCj20qay0x4tRxbyI0917yaai2KFbUCiVuihqEZu8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","content":"A andeboltv pretende levar até si os melhores conteúdos do andebol nacional e internacional. "},{"name":"keywords","content":null},{},{"property":"og:title","content":"Federação de Andebol de Portugal"},{"property":"og:type","content":"article"},{"property":"og:image","content":"https://andeboltv.fpa.pt/images/customer/metaImage.png"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"property":"og:description","content":"A andeboltv pretende levar até si os melhores conteúdos do andebol nacional e internacional. "},{"property":"og:site_name","content":"Federação de Andebol de Portugal"},{"property":"og:url","content":"https://andeboltv.fpa.pt"},{"property":"article:published_time","content":"6/5/2025"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:site","content":"https://www.twitter.com/AndebolPortugal/"},{"name":"twitter:title","content":"Federação de Andebol de Portugal"},{"name":"twitter:description","content":"A andeboltv pretende levar até si os melhores conteúdos do andebol nacional e internacional. "},{"name":"twitter:image:src","content":"https://andeboltv.fpa.pt/images/customer/metaImage.png"},{"name":"twitter:image:alt","content":"/images/customer/metaImage.png image"},{"name":"apple-itunes-app","content":"app-id=6444163367, app-argument=https://andeboltv.fpa.pt"},{"property":"fb:app_id","content":"639250024490966"}],"link":[{"rel":"icon","type":"image/svg+xml","href":"/images/customer/favicon.png"}],"style":[{"innerHTML":"\n              :root {\n                --base-customer-color: #a20c17;\n                --base-primary-accent-color: initial;\n              }\n            "}],"script":[{"id":"imaSDK","type":"text/javascript","src":"https://imasdk.googleapis.com/js/sdkloader/ima3.js"},{"type":"text/javascript","src":"https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1"}],"noscript":[],"title":"Federação de Andebol de Portugal"}

export const appBaseURL = "/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true